import React from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import { AkCreateDrawer, AkNavigationItemGroup, AkNavigationItem } from '@atlaskit/navigation';
import BitbucketReposIcon from '@atlaskit/icon/glyph/bitbucket/repos';
import InviteTeamIcon from '@atlaskit/icon/glyph/invite-team';

// @source
import { PrimaryIcon, DrawerBackButton } from './Similar';
import { RouteNavLink } from '..';

const CreateDrawer = ({ isOpen, onBackHandle }) => {
  const groups = [
    {
      title: 'Create',
      items: [
        ['/reports/create', 'Report', BitbucketReposIcon],
        ['/users/create', 'User', InviteTeamIcon],
      ],
    },
  ];
  return (
    <AkCreateDrawer
      backIcon={DrawerBackButton()}
      isOpen={isOpen}
      onBackButton={onBackHandle}
      primaryIcon={PrimaryIcon}
    >
      {groups.map(({ title, items }) => (
        <AkNavigationItemGroup key={title} title={title}>
          {items.map(([url, text, Icon]) => (
            <AkNavigationItem
              href={url}
              icon={<Icon label={text} />}
              key={url}
              linkComponent={RouteNavLink}
              onClick={onBackHandle}
              text={text.valueOf()}
            />
          ))}
        </AkNavigationItemGroup>
      ))}
    </AkCreateDrawer>
  );
};

CreateDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onBackHandle: PropTypes.func.isRequired,
};

CreateDrawer.defaultProps = {
  isOpen: false,
};

export default CreateDrawer;
